import { BaseDataModel } from "@domain/CRM/BaseDataModel";

export class Branch extends BaseDataModel {
	name!: string;
	labAccountNumber!: string;
	salespersonIds!: string[];
	externalLocationId?: string[];
}
